<template>
  <div class="analysis-tabs">
    <a-tabs
      :default-active-key="1"
      :tabBarStyle="{ borderBottom: '0' }"
      class="tab"
      :tabBarGutter="10"
    >
      <!-- tab 1-->
      <a-tab-pane key="1" :tab="tab1" id="mod1">
        <div class="tabContent">
          <chart-table
            :tab="tab1"
            :form="formData"
            v-if="chartsData1.length != 0"
            :chartsData="chartsData1"
            :tableData="tableData1"
            @getTableData="_getChartList"
          ></chart-table>
        </div>
      </a-tab-pane>

      <!-- tab 2-->
      <a-tab-pane key="2" :tab="tab2" id="mod2">
        <div class="tabContent">
          <chart-table
            :tab="tab2"
            :form="formData"
            v-if="chartsData2.length != 0"
            :chartsData="chartsData2"
            :tableData="tableData2"
            :getTableData="_getChartList"
          ></chart-table>
        </div>
      </a-tab-pane>
      <!-- tab 3-->
      <a-tab-pane key="3" :tab="tab3" id="mod3">
        <div class="tabContent">
          <chart-table
            :tab="tab3"
            :form="formData"
            v-if="chartsData3.length != 0"
            :chartsData="chartsData3"
            :tableData="tableData3"
            :getTableData="_getChartList"
          ></chart-table>
        </div>
      </a-tab-pane>
      <!-- tab 4-->
      <a-tab-pane key="4" :tab="tab4" id="mod4">
        <div class="tabContent">
          <chart-table
            :tab="tab4"
            :form="formData"
            v-if="chartsData4.length != 0"
            :chartsData="chartsData4"
            :tableData="tableData4"
            @getTableData="_getChartList"
          ></chart-table>
        </div>
      </a-tab-pane>
      <!-- tab 5-->
      <a-tab-pane key="5" :tab="tab5" id="mod5">
        <div class="tabContent">
          <chart-table
            :tab="tab5"
            :form="formData"
            v-if="chartsData5.length != 0"
            :chartsData="chartsData5"
            :tableData="tableData5"
            :getTableData="_getChartList"
          ></chart-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import ChartTable from './ChartTable'
import { getChartList } from '../api'

import mixin from './mixin'
export default {
  mixins: [mixin],
  components: {
    ChartTable,
  },
  props: ['form'],
  data() {
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      chartsData1: [],
      chartsData2: [],
      chartsData3: [],
      chartsData4: [],
      chartsData5: [],
      tab1: '主要财务指标',
      tab2: '盈利能力指标',
      tab3: '偿债能力指标',
      tab4: '成长能力指标',
      tab5: '运营能力指标',
      formData: {},
    }
  },
  watch: {
    handler(newValue) {
      this.formData = newValue.formData
    },
  },
  mounted() {
    this.formData = this.form
    this._getChartList()
  },
  methods: {
    async _getChartList() {
      this.chartsData1 = []
      this.chartsData2 = []
      this.chartsData3 = []
      this.chartsData4 = []
      this.chartsData5 = []
      this.tableData1 = []
      this.tableData2 = []
      this.tableData3 = []
      this.tableData4 = []
      this.tableData5 = []
      try {
        const {
          data: { charts, table },
        } = await getChartList(this.formData)

        table.forEach(item => {
          let idx = item.type
          item.flag = false
          this['tableData' + idx].push(item)
        })

        charts.forEach(item => {
          let idx = item.type
          this['chartsData' + idx].push(item)
        })
        this.chartsData1 = this.chartsData1.slice(0, 3)
        this.chartsData2 = this.chartsData2.slice(0, 3)
        this.chartsData3 = this.chartsData3.slice(0, 3)
        this.chartsData4 = this.chartsData4.slice(0, 3)
        this.chartsData5 = this.chartsData5.slice(0, 3)
        this.renderItem(this.chartsData1, this.tableData1)
        this.renderItem(this.chartsData2, this.tableData2)
        this.renderItem(this.chartsData3, this.tableData3)
        this.renderItem(this.chartsData4, this.tableData4)
        this.renderItem(this.chartsData5, this.tableData5)
      } catch (err) {
        console.log(err)
      }
    },
    renderItem(arrCharts, arrTables) {
      arrCharts.forEach(item => {
        arrTables.forEach(tableItem => {
          if (item.key == tableItem.key) {
            tableItem.flag = true
          }
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin: 0;
}
.tabContent {
  padding: 20px;
  background-color: #fff;
}
.analysis-tabs /deep/ .ant-tabs-nav-scroll {
  background-color: #fff;
  padding: 10px;
}
</style>
